/**
 * Start: displayFeedbackPanel
 *
 * Generic method to display the feedback panel
 *
 * @param object panelSettings  - The settings for the panel
 * @param object panelContainer - The container that holds the html
 * @param string string type    - The type of panel to display: error, info, success
 * @param string string message - The message to display
 *
 * @return void
 */
function displayFeedbackPanel(panelSettings, panelContainer, type, message) {

    // default panel settings
    const defaultPanelSettings = {
        default: {panelClass: 'panel-default', panelHeading: "See below message."},
        error: {panelClass: 'panel-danger', panelHeading: "Error!"},
        info: {panelClass: 'panel-info', panelHeading: "Info!"},
        success: {panelClass: 'panel-success', panelHeading: "Success!"},
    };

    // if a custom settings are not given, use the default settings
    const settings = panelSettings || defaultPanelSettings;

    // remove existing panel classes, in order to display the new one
    Object.values(settings).forEach(({ panelClass }) => {
        if (panelContainer.hasClass(panelClass)) {
            panelContainer.removeClass(panelClass);
        }
    });

    const panelType = settings[type] || settings.default;
    const { panelClass, panelHeading } = panelType;

    panelContainer.addClass(panelClass);
    panelContainer.find(".panel-heading").html(panelHeading).end();
    panelContainer.find('.panel-body').html(message);
    panelContainer.fadeIn();
}

/**
 * End: displayFeedbackPanel
 */


/**
 * Start: hideFeedbackPanel
 *
 * Hide the feedback panel
 *
 * @param object panelContainer - The container that holds the html
 *
 * @return void
 */
function hideFeedbackPanel(panelContainer) {
    panelContainer.hide();
    panelContainer.find(".panel-heading").html("");
    panelContainer.find('.panel-body').html("");
}
/**
 * End: hideFeedbackPanel
 */
